import type { EffectBuild } from "@skilitics/nautilus-core-designer-data";

import type { DesignerEffect, EffectBuildable } from "../../types/index.ts";

interface MakeEffectCreateOptions {
  buildables: EffectBuildable[];
}

export const makeEffectCreate =
  ({ buildables }: MakeEffectCreateOptions) =>
  ({ id, buildableName, nodeId, config }: EffectBuild): DesignerEffect | undefined => {
    const buildable = buildables.find((b) => b.name === buildableName && b.nodeId === nodeId);
    if (!buildable) {
      console.warn(`Effect Buildable not found on nodeId ${nodeId} with name ${buildableName}.`);
      return undefined;
    }

    const { builder, spec } = buildable;

    // isValid should default to true unless an effect builder explicitly defines why it is invalid.
    const isValid = builder.isValid?.(config, spec) ?? true;

    return {
      id,
      builder,
      spec,
      config,
      isValid,
    };
  };

export type MakeEffect = ReturnType<typeof makeEffectCreate>;
